
<style lang="less">
.vertical-center-modal {
  display: flex;
  align-items: center;
  justify-content: center;
  .ivu-modal {
    top: 0;
  }
}
</style>

<template>
  <Modal
    v-model="modalGraphSvg"
    width="1400"
    footer-hide
    class-name="vertical-center-modal"
  >
    <div>
      <Tabs v-if="categorys.length > 0" v-model="query.categoryId">
        <TabPane
          v-for="(item, index) in categorys"
          :key="index"
          :label="item.name"
          :name="item.id+''"
        >
        </TabPane>
      </Tabs>
      <Table
        id="station_table"
        :loading="loading"
        stripe
        :columns="columns"
        :data="tableData"
      ></Table>
      <div class="m-t-10">
        <Page
          :current="query.pageNumber"
          :total="resultTotalRow"
          :page-size="query.pageSize"
          show-total
          @on-change="handlePageChange"
        />
      </div>
    </div>
  </Modal>
</template>

<script>
import { getproductsku } from '@/api/product'
import { toMoneyNoPrefix } from '@/utils/wnumb_own'

export default {
  data () {
    return {
      loading: false,
      categorys: [],
      cityCode: '',

      modalGraphSvg: false,

      query: {
        pageNumber: 1,
        pageSize: 10,
        cityCode: '',
        categoryId: 0
      },
      resultTotalRow: 0,
      tableData: [],
      columns: [
        {
          title: '名称',
          key: 'productskuName'
        },
        {
          title: '刊例价(元)',
          key: 'usePrice',
          render: (h, params) => {
            return h('span', params.row.usePrice === 0 ? '-' : toMoneyNoPrefix(params.row.usePrice))
          }
        },
        {
          title: '所属线路',
          key: 'usePrice',
          render: (h, params) => {
            return h('span', params.row.assetNames.join(','))
          }
        },
        {
          title: '最小连续售卖天数',
          key: 'minday',
          render: (h, params) => {
            return h('span', params.row.minday === 0 ? '-' : params.row.minday)
          }
        },
        {
          title: '所属营运方',
          key: 'operator',
          render: (h, params) => {
            return h('span', params.row.operator ? params.row.operator : '-')
          }
        },
        {
          title: '采购',
          key: 'operatorTel',
          // render: (h, params) => {
          //   return h('span', params.row.operatorTel ? params.row.operatorTel : '-')
          // },
          render: (h, params) => {
            const detailButton = h(
              'Icon',
              {
                style: {
                  marginRight: '5px',
                  cursor: 'pointer'
                },
                props: { type: 'md-contact', size: 24, color: '#2D8cF0' },
                on: {
                  click: () => {
                    if (params.row.operator) {
                      let data = {
                        productskuId: params.row.productskuId,
                        productskuName: params.row.productskuName,
                        usePrice: params.row.usePrice,
                        formatuseprice: toMoneyNoPrefix(params.row.usePrice),
                        assetIdList: params.row.assetIdList,
                        assetNames: params.row.assetNames.toString(','),
                        minday: params.row.minday,
                        operator: params.row.operator,
                        linkuserName: params.row.imUsername
                      }
                      this.$emit('showonlineService', data)
                    }
                  }
                }
              }
            )
            return h('div', [
              detailButton
            ])
          }
        }
      ]
    }
  },
  methods: {
    showModel (categorys, cityCode) {
      this.categorys = categorys
      this.query.cityCode = cityCode
      if (this.categorys.length) {
        this.query.categoryId = this.categorys[0].id + ''
        this.loadproductsk()
      }
      this.modalGraphSvg = true
    },
    loadproductsk () {
      this.loading = true
      getproductsku(this.query).then(res => {
        this.resultTotalRow = res.totalRow
        this.tableData = res.list
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    handlePageChange (page) {
      this.query.pageNumber = page
      this.loadproductsk()
    }
  },
  watch: {
    'query.categoryId': function (val) {
      this.query.pageNumber = 1
      this.loadproductsk()
    }
  }
}
</script>
